export default {
      id: "graph-laval-usage",
      viewBox: "0 0 132 132",
      url: __webpack_public_path__ + "svg/sprite.svg#graph-laval",
      toString: function () {
        return this.url;
      }
    }